module.exports = {"unspecified":"Hodor","horde":"Hodor","alliance":"Hodor"};